<template>
  <div class="login">
    <div class='login-header'>
      ФБУ "Рослесозащита"
    </div>
    <div class="login-title">
      Автоматизированная аналитическая система "ГЛПМ - контроль"
    </div>
    <div class='login-wrapper'>
      <form id='login-form' class="form-signin" role="form" @submit.prevent="submit">
        <h2 class="form-signin-heading">Авторизация</h2>
        <input id='input-login' v-model="user.login" type="text" class="form-control" placeholder="Логин"></input>
        <input type="password" v-model="user.password" class="form-control" placeholder="Пароль" enterSubmit></input>        
        <label class="checkbox text-center">
          <input v-model="user.remember" id="remember" type="checkbox" value="remember-me"/> <span style='font-color: white'>Запомнить меня</span>
        </label>
        <button type="submit" class='btn btn-primary btn-color'>Войти</button>
        <alert v-if='error' type='danger'>Логин или пароль введены неверно</alert>
        <alert v-if='error_db' type='danger'>Отсутствует подключение к БД</alert>
      </form>
    </div>
  </div>
</template>

<script>
  import auth from '../auth'
  import {BACK} from '../constants'

  import { alert } from 'vue-strap'

  export default {
    data () {
      return {
        // We need to initialize the component with any
        // properties that will be used in it
        user: {
          login: '',
          password: '',
          remember: false
        },
        error: false,
        error_db: false
      }
    },
    methods: {
      submit: function () {
        var credentials = {
          login: this.user.login,
          password: this.user.password,
          remember: this.user.remember
        }
        // We need to pass the component's this context
        // to properly make use of http in the auth service
        auth.login(this, credentials, '/main')
      }
    },
    components: {
      alert
    }

  /*export default {
    name: 'login',
    data () {
      return {
        user: {
          login: '',
          password: '',
          remember: false
        }
      }
    },
    methods: {
      checkAuth: function () {
        var data = new FormData()
        data.append('login', this.user.login)
        data.append('password', this.user.password)
        data.append('remember', this.user.remember)
        fetch('http://localhost/garbage/vbtest/src/php/auth.php', {
          method: 'POST',
          body: data
        })
        .then(res => res.json())
        .then(res => {
          if (res !== -1) {
            router.replace('main')
          } else {
          	//router.replace('forbidden')
            console.log('failure')
          }
        })
        .catch(e => {
          console.log(e)
        })
      }
    }*/
  }
</script>

<style scoped>
.login {
    margin: 0px;
    height: 100vh;
  }

  .login-header {
    width: 100vw;
    height: 50px;
    color: white;
    -webkit-text-stroke: 1px black;
    background-color: rgba(117, 190, 218, 0.25);
    font-size: 32px;
    font-weight: bold;
    text-align: center;
  }

  .login-title {
    /*margin-top: 15%;*/
    /*width: 45%;*/
    width: 100vw;
     color: white;
     -webkit-text-stroke: 1px black;
    background-color: rgba(117, 190, 218, 0.25);
    font-size: 32px;
    text-align: center;
    padding: 10px;
     font-weight: bold;
    -moz-border-radius: 10px;
    -webkit-border-radius: 10px;
  }

  .login-wrapper {
   padding-top: 10%;
   /*padding-left: 60%;*/
  }

  .form-signin {
    max-width: 240px;
    padding: 15px;
    margin: 0 auto;
    /*background-color: white;*/
    color: white;
    -webkit-text-stroke: 0.2px lightblue;
    background-color: rgba(117, 190, 218, 0.25);
    -moz-border-radius: 10px;
    -webkit-border-radius: 10px;
  }

  .btn-color {
    background-color: rgba(59, 73, 79);
  }

  .form-signin .form-signin-heading{
    margin-bottom: 25px;
    text-align: center;
     -webkit-text-stroke: 1px black;
     font-weight: bold;
  }
  .form-signin .checkbox {
    font-weight: normal;
    padding-left: 20px;
  }
  .form-signin .form-control {
    position: relative;
    height: auto;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 10px !important;
    font-size: 16px !important;
  }
  .form-signin .form-control:focus {
    z-index: 2;
  }
  .form-signin input[type="text"] {
    margin-bottom: 10px;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    
  }
  .form-signin input[type="password"] {
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;

  }
  .error_text {
    color: #FF0000;
    text-align: center;
  }

  .form-signin button[type="submit"] {
    width: -webkit-fill-available;
    width: -moz-available;
  }

/*   .modal-body {
  padding-bottom: 0px;
} */

  .alert {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// Login.vue?3aeade77